import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import TailwindTheme from 'tailwindcss/defaultTheme';

import type { MerchantFontSizeEnum, UseCase } from 'src/api/models';

export function sleep(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}

export function assertString(val: unknown): asserts val is string {
  if (!val || typeof val !== 'string') {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    throw new Error(`unexpected non string value: ${val}`);
  }
}

export function assertDefined<T>(val: undefined | T): asserts val is T {
  if (val === undefined) {
    throw new Error('unexpected undefined');
  }
}

export function fileExtension(filename: string): string {
  return filename
    .slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2)
    .toLowerCase()
    .trim();
}

export function parseHtmlStringToReact(str: string) {
  return parse(str);
}

export function useParsedHtmlString(str: string | undefined) {
  const [rendered, setRendered] = useState<React.ReactNode>(null);
  useEffect(() => {
    if (!str) {
      setRendered(null);
      return;
    }
    const element = parse(str);
    setRendered(element);
  }, [str]);
  return rendered;
}

export function isUseCaseAbandonedCart(useCase: UseCase): boolean {
  return useCase.name.includes('abandoned');
}

export function removeNulls<T>(obj: T | null | undefined): obj is T {
  return obj !== null || obj !== undefined;
}
export function mapFontSizes(merchangeFontSize: MerchantFontSizeEnum): `text-${keyof typeof TailwindTheme.fontSize}` {
  type FontSizeRawToTwnd = Record<MerchantFontSizeEnum, `text-${keyof typeof TailwindTheme.fontSize}`>;
  const fontSizeRawToTwnd: FontSizeRawToTwnd = {
    XS: 'text-xs',
    SM: 'text-sm',
    BASE: 'text-base',
    LG: 'text-lg',
    XL: 'text-xl',
    TWO_XL: 'text-2xl',
    THREE_XL: 'text-3xl',
    FOUR_XL: 'text-4xl',
  };
  return fontSizeRawToTwnd[merchangeFontSize];
}

export function replaceDemoStoreName(text: string, storeKeyName: string | undefined): string {
  if (storeKeyName != 'maverickdemo') {
    return text;
  }
  return text.replaceAll('JAVY', 'MAVERICK').replaceAll('Javy', 'Maverick').replaceAll('javy', 'maverick');
}
